module.exports = __webpack_public_path__ + "static/img/none.b01d81f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/none.png
// module id = UF9J
// module chunks = 1